import { get, post, put, destroy, patch } from "./base";

const ProductServ = {
  // Get all products
  index: (params) => get("/products", { params }),

  // Seller - Get own products
  getSellerProducts: (params) => get("/products/seller/my-products", { params }),

  // Admin - Get all products (including active, including variants/options)
  getAdminProducts: (params) => get("/products/admin/all-products", { params: { includeOptions: true, ...params } }),

  // Admin - Inventory Audit aggregated data
  getInventoryAudit: (productIds) => get("/products/admin/inventory-audit", { params: { productIds: JSON.stringify(productIds) } }),

  // Get single product by ID
  single: (id, params) => get(`/products/${id}`, { params }),

  // Get products by shop ID
  getByShop: (shopId, params) => get(`/products/shop/${shopId}`, { params }),

  // Get products by category
  getByCategory: (category, params) => get(`/products/category/${category}`, { params }),

  // Get products by category grouped by shop (for category page)
  getByCategoryGrouped: (category, params) => get(`/products/category/${category}/grouped`, { params }),

  // Search products
  search: (searchTerm, params) => get("/products/search/query", { params: { ...params, search: searchTerm } }),

  // Get home category products
  getHomeCategoryProducts: (params) => get("/products/home-categories/list", { params }),

  // Get related products
  getRelatedProducts: (id, params) => get(`/products/related/${id}`, { params }),

  // Create product
  create: (payload) => post("/products", payload),

  // Update product
  update: (id, payload) => put(`/products/${id}`, payload),

  // Delete product
  // Delete product
  remove: (id, params) => destroy(`/products/${id}`, { params }),

  // Restore product
  restore: (id) => put(`/products/${id}/restore`),

  // Upload Config
  getUploadConfig: () => get("/products/upload/config"),

  // Upload Image
  uploadImage: (formData) => post("/products/upload", formData),

  // Update Product Status (Admin)
  updateStatus: (id, status, rejectionReason) =>
    patch(`/products/${id}/status`, { status, rejectionReason }),

  // Bulk Update Product Status
  bulkUpdateStatus: (productIds, status, rejectionReason) =>
    patch(`/products/bulk/status`, { productIds, status, rejectionReason }),

  // Bulk Remove Products
  bulkDelete: (productIds, params) => {
    return destroy("/products/bulk", { data: { productIds }, params });
  },
};

export default ProductServ;
